<template>
  <div class="section">
    <div clsas="section_img"><img :src="topMenu.img" /></div>
    <div class="section_text">
      <h2>{{ topMenu.title }}</h2>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    topMenu: Object,
  },
  created() {},
}
</script>

<style>
.section {
  position: relative;
  width: 100%;
}
.section .section_img {
  width: 100%;
  position: relative;
}
.section img {
  width: 100%;
  height: 250px;
  object-fit: cover;
}
.section .section_text {
  top: 0;
  position: absolute;
  width: 100%;
  height: 250px;
  background-color: rgba(59, 58, 58, 0.575);
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.section .section_text > h2 {
  font-family: 'NanumBarunGothic';
  font-size: 60px;
  font-weight: 300;
  text-transform: uppercase;
  letter-spacing: 2px;
  color: #fff;
  margin: 0;
}
</style>
